export const useUser = () => useState('user', () => ({} as Store.User))
export const useMenu = () => useState('menu', () => ({ collapsed: false, width: 200 }))
export const useArticle = () => useState('article', () => ({} as Store.Article))
